import { Controller } from "react-hook-form";
import { fontSizes } from "../../constants/constants";
import textWeight from "../../utils/textWeight";
import Text from "../Text";
import Functions from "./index.function";
const InputField = ({
  type,
  name,
  placeholder,
  label,
  sublabel,
  register,
  validation,
  control,
  errors,
  icon,
  isPassword = false,
  iconPasswordVisible,
  iconPasswordHidden,
  is_ForgotPassword,
  isMandatory,
  iconStyle,
  maxLength,
  cardIcon,
}) => {
  const {
    inputRef,
    handleCardIconClick,
    isPasswordVisible,
    togglePasswordVisibility,
    navigate,
  } = Functions();

  return (
    <div className="mx-[2px]">
      {label && (
        <Text
          text={
            <>
              {label}
              {sublabel && <Text text={sublabel} color="text-gray" />}
            </>
          }
          size={fontSizes.h16}
          weight={textWeight.Onest_regular}
          isRequired={isMandatory}
          color="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary"
        />
      )}

      {/* Input Field */}
      <div className="relative">
        <Controller
          name={name}
          control={control}
          rules={validation}
          render={({ field }) => (
            <input
              maxLength={maxLength}
              {...field}
              ref={(e) => {
                field.ref(e);
                inputRef.current = e;
              }}
              className="xs:pl-6 xs:!mb-[2px] sm:mb-1 sm:pl-6 lg:pl-8 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-4 rounded-full focus:outline-none text-[#808080] focus:bg-primary transition duration-300 delay-100 focus:ring-2 focus:ring-goldMetallic"
              type={
                isPassword ? (isPasswordVisible ? "text" : "password") : type
              }
              min={
                type === "date"
                  ? new Date().toISOString().split("T")[0]
                  : undefined
              }
              placeholder={placeholder || "Type here..."}
            />
          )}
        />

        {/* Left Icon */}
        {icon && (
          <img
            className={`absolute left-5 3xl:left-8 top-1/2 transform -translate-y-1/2 ${iconStyle}`}
            src={icon}
            alt={`${name} icon`}
          />
        )}

        {/* Card Icon (For date input) */}
        {cardIcon && (
          <img
            className="absolute xs:right-14 right-16 top-1/2 transform -translate-y-1/2"
            src={cardIcon}
            alt={`${name} cardIcon`}
            onClick={handleCardIconClick}
          />
        )}

        {/* Password Toggle Icon */}
        {isPassword && (
          <img
            className="absolute right-5 top-1/2 transform -translate-y-1/2 xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-6 w-7 cursor-pointer 3xl:right-8 3xl:w-8 3xl:h-7"
            src={isPasswordVisible ? iconPasswordVisible : iconPasswordHidden}
            alt={isPasswordVisible ? "Show password" : "Hide password"}
            onClick={togglePasswordVisibility}
          />
        )}
      </div>

      {/* Validation Errors */}
      <div
        className={`${
          is_ForgotPassword
            ? "flex justify-between items-start"
            : "flex justify-start items-start"
        }`}
      >
        <div className="flex justify-start items-center xs:pl-6 sm:pl-6 lg:pl-8 xs:pt-[2px] sm:pt-1">
          {errors?.[name] && (
            <span className="text-orangeCrayola font-onestRegular xs:text-xs sm:text-sm">
              {errors[name].message}
            </span>
          )}
        </div>
        {is_ForgotPassword && (
          <div className={`xs:pr-6 sm:pr-6 lg:pr-8`}>
            <p
              className="text-secondary cursor-pointer hover:text-orangeCrayola hover:underline xs:text-sm"
              onClick={() => {
                navigate("/forget-password");
              }}
            >
              Forgot Password
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default InputField;
